import styled from "@emotion/styled";

export const ColumnFlex = styled.div`
  display: flex;
  height: fit-content;
  flex-direction: column;
  padding-left: 16px;
  gap: 24px;
  width: 100%;
`;

export const HorizontalScrollbox = styled.div`
  display: flex;
  width: 100%;
  overflow-x: scroll;

  img {
    margin: 0 0.5rem;
  }
`;

export const SpaceBetweenFlex = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SpaceBetweenColumnFlex = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;
